export const SIAStationIcon = (size = 14) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="14" height="14" rx="2" fill="#142354" />
    <path
      d="M4.92054 11.9766C4.92054 11.9766 6.52547 9.57947 6.67003 9.34249C6.8467 9.05248 6.85458 8.59185 6.69579 8.34426C6.61457 8.21486 4.22172 4.43012 4.22172 4.43012C4.00686 4.02162 4.0605 3.74221 4.20384 3.5428C4.43961 3.19491 4.85569 2.5776 4.85569 2.5776C4.85569 2.5776 7.76069 7.13511 7.8816 7.33845C8.19344 7.85817 8.10707 8.36759 7.85009 8.80398C7.63462 9.17157 5.75271 11.9766 5.75271 11.9766"
      fill="#F79210"
    />
    <path
      d="M4.40217 12.23C4.40217 12.23 6.25953 9.51104 6.39772 9.28587C6.55924 9.01071 6.54167 8.62311 6.39772 8.38916C6.32014 8.26552 3.74092 4.20653 3.74092 4.20653C3.74092 4.20653 3.28362 4.89656 3.13907 5.1096C2.99482 5.32173 2.90936 5.58629 3.15695 6.01177C3.15695 6.01177 5.00371 8.92707 5.08159 9.05041C5.2319 9.2886 5.22554 9.72529 5.05735 10.0005C4.91946 10.2223 3.01452 13 3.01452 13H8.51116C9.06937 13 9.37575 12.783 9.64576 12.3945C9.87941 12.0645 10.7837 10.7505 10.9225 10.5444C11.0592 10.338 11.3346 10.2008 11.458 10.2008H11.8874L11.0495 8.92585H9.71213C9.45696 8.92585 9.14847 9.15253 8.98603 9.39285C8.85906 9.58225 7.94446 10.9523 7.77991 11.1726C7.68627 11.2969 7.60627 11.3245 7.53202 11.3251C7.49111 11.3251 7.37292 11.3245 7.35837 11.3245C7.41262 11.2148 8.94876 8.9804 9.25059 8.48826C9.61576 7.88247 9.69819 7.08243 9.26423 6.31512C9.10543 6.03662 5.91345 1 5.91345 1C5.91345 1 5.48828 1.61215 5.3113 1.87398C5.16766 2.08824 5.12372 2.36795 5.33039 2.77706C5.33039 2.77706 8.00962 7.03849 8.1375 7.23395C8.44873 7.72004 8.40994 8.36916 8.1375 8.81191C7.91507 9.17617 6.06376 11.9712 6.06376 11.9712H7.5305C8.06205 11.9712 8.19205 11.7742 8.33842 11.6108C8.4851 11.4469 9.28302 10.2371 9.37332 10.1096C9.46545 9.98318 9.69819 9.62619 10.0043 9.62619H10.9673V9.65407C10.7622 9.69529 10.5601 9.81923 10.4134 10.0202C10.2667 10.219 9.29847 11.6527 9.1821 11.8199C9.03543 12.0303 8.86784 12.23 8.44661 12.23"
      fill="#F79210"
    />
  </svg>
);

export const scootIcon = (size = 14) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="14" height="14" rx="2" fill="white" />
    <g clipPath="url(#clip0_2724_119097)">
      <path
        d="M6.29608 12.5922C9.21229 12.5922 11.5922 10.2291 11.5922 7.29609C11.5922 4.37989 9.22905 2 6.29608 2C3.37988 2 1 4.36313 1 7.29609C1 10.2291 3.36312 12.5922 6.29608 12.5922Z"
        fill="#FFE900"
      />
      <path
        d="M11.3227 7.02741L11.8255 6.89333L12.2277 8.53579L12.9987 8.35143L12.9819 7.89892L12.7641 7.94919L12.4624 6.74249L12.9987 6.60841L12.8646 6.00506L12.3283 6.13914L12.1607 5.46875L11.5741 5.87098L11.6747 6.28998L11.1719 6.42406L11.306 7.02741"
        fill="#1D1D1B"
      />
      <path
        d="M11.2428 6.47582C11.0417 6.2747 10.7568 6.14062 10.3881 6.14062C9.58358 6.14062 9.19811 6.7775 9.19811 7.31381C9.19811 7.85012 9.58358 8.48699 10.3881 8.48699C11.1925 8.48699 11.578 7.85012 11.578 7.31381C11.578 7.07917 11.511 6.84454 11.3769 6.64342L11.2428 6.47582ZM10.9076 7.31381C10.9076 7.63225 10.673 7.86688 10.3713 7.86688C10.0864 7.86688 9.83497 7.63225 9.83497 7.31381C9.83497 6.99537 10.0696 6.76074 10.3713 6.76074C10.673 6.76074 10.9076 6.99537 10.9076 7.31381ZM9.18136 7.31381C9.18136 6.7775 8.79587 6.14062 7.9914 6.14062C7.18693 6.14062 6.80146 6.7775 6.80146 7.31381C6.80146 7.85012 7.18693 8.48699 7.9914 8.48699C8.79587 8.48699 9.18136 7.85012 9.18136 7.31381ZM8.52772 7.31381C8.52772 7.63225 8.29307 7.86688 7.9914 7.86688C7.70648 7.86688 7.45509 7.63225 7.45509 7.31381C7.45509 6.99537 7.68972 6.76074 7.9914 6.76074C8.27631 6.76074 8.52772 6.99537 8.52772 7.31381ZM6.14782 7.06241H6.81821C6.7009 6.5261 6.23162 6.14062 5.64503 6.14062C4.9914 6.14062 4.48862 6.66018 4.48862 7.31381C4.48862 7.96744 5.00817 8.48699 5.66181 8.48699C6.26516 8.48699 6.7009 8.08476 6.81821 7.58197H6.14782C6.08078 7.71604 5.94672 7.88364 5.67856 7.88364C5.36013 7.88364 5.15901 7.64901 5.15901 7.33057C5.15901 7.17973 5.20928 7.0289 5.30983 6.92834C5.41039 6.82778 5.54448 6.76073 5.69532 6.77749C5.92995 6.74397 6.06402 6.91157 6.14782 7.06241ZM3.7847 6.82778H4.43833C4.38805 6.24118 3.88526 6.14062 3.58359 6.14062C3.13107 6.14062 2.72884 6.42554 2.72884 6.89481C2.72884 7.19649 2.96348 7.38085 3.24839 7.46465C3.66739 7.63224 3.83499 7.649 3.83499 7.79984C3.83499 7.9004 3.71766 7.96744 3.60034 7.96744C3.56682 7.96744 3.38247 7.96744 3.34895 7.76633H2.69531C2.76235 8.35292 3.26515 8.50375 3.60034 8.50375C4.08638 8.50375 4.50538 8.21884 4.50538 7.7328C4.50538 7.26353 4.10315 7.14621 3.73443 7.04565C3.56683 6.99537 3.39924 6.92834 3.39924 6.82778C3.39924 6.76074 3.44951 6.67694 3.58359 6.67694C3.76795 6.66018 3.7847 6.7775 3.7847 6.82778Z"
        fill="#1D1D1B"
      />
    </g>
    <defs>
      <clipPath id="clip0_2724_119097">
        <rect
          width="12"
          height="10.5922"
          fill="white"
          transform="translate(1 2)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const satIcon = (size = 14) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="14" height="14" rx="2" fill="white" />
    <g clipPath="url(#clip0_2724_119674)">
      <mask
        id="mask0_2724_119674"
        maskUnits="userSpaceOnUse"
        x="-57"
        y="-61"
        width="140"
        height="195"
      >
        <path
          d="M-56.2891 133.188H82.2046V-60.5203H-56.2891V133.188Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_2724_119674)">
        <path
          d="M12.9526 7.00348C12.9526 10.2201 10.3157 12.8281 7.06222 12.8281C3.80878 12.8281 1.17188 10.2201 1.17188 7.00348C1.17188 3.78594 3.80878 1.17814 7.06222 1.17814C10.3157 1.17814 12.9526 3.78594 12.9526 7.00348Z"
          fill="#B5121B"
        />
        <path
          d="M5.31972 6.90883C5.18083 6.81242 4.96143 6.75053 4.65573 6.71533C4.44494 6.69186 3.83027 6.68519 3.83027 6.50273C3.83027 6.44474 3.86075 6.39896 3.9573 6.35777C4.05199 6.31843 4.20275 6.29749 4.40609 6.29749C4.91072 6.29749 5.19851 6.5186 5.19851 6.5186L5.49165 6.16588C5.49165 6.16588 5.03007 5.83847 4.39934 5.83847C4.08247 5.83847 3.8319 5.89806 3.64903 6.02369C3.46686 6.14747 3.35938 6.31337 3.35938 6.50273C3.35938 6.68265 3.43894 6.84694 3.55853 6.94242C3.67695 7.03768 3.82678 7.09635 4.07409 7.13823C4.13342 7.14743 4.29092 7.16676 4.54754 7.18102C4.70993 7.18931 4.82952 7.20702 4.90234 7.23118C5.03612 7.2772 5.08172 7.3384 5.08265 7.42376C5.08265 7.50268 5.04286 7.56619 4.93538 7.62578C4.82952 7.68169 4.67364 7.71275 4.46867 7.71275C3.99964 7.71275 3.66508 7.49578 3.66508 7.49578L3.37543 7.84505C3.37543 7.84505 3.78281 8.17845 4.47472 8.17178C4.60245 8.16994 4.71947 8.16073 4.8251 8.14163C5.00215 8.11149 5.14942 8.05604 5.26714 7.97413C5.38836 7.88946 5.47211 7.7781 5.51608 7.64327C5.534 7.59725 5.55261 7.49762 5.55261 7.40375C5.55261 7.18769 5.47397 7.01513 5.31972 6.90883ZM12.0493 6.90883C11.9113 6.81242 11.691 6.75053 11.3853 6.71533C11.1745 6.69186 10.5598 6.68519 10.5598 6.50273C10.5598 6.44474 10.5903 6.39896 10.6868 6.35777C10.7815 6.31843 10.9323 6.29749 11.1356 6.29749C11.6402 6.29749 11.928 6.5186 11.928 6.5186L12.2212 6.16588C12.2212 6.16588 11.7596 5.83847 11.1289 5.83847C10.812 5.83847 10.5614 5.89806 10.3786 6.02369C10.1964 6.14747 10.0889 6.31337 10.0889 6.50273C10.0889 6.68265 10.1694 6.84694 10.2878 6.94242C10.4065 7.03768 10.5572 7.09635 10.8036 7.13823C10.8636 7.14743 11.0205 7.16676 11.2778 7.18102C11.4404 7.18931 11.5598 7.20702 11.6316 7.23118C11.7656 7.2772 11.8122 7.3384 11.8129 7.42376C11.8122 7.50268 11.7724 7.56619 11.6647 7.62578C11.5588 7.68169 11.4032 7.71275 11.1982 7.71275C10.7292 7.71275 10.3946 7.49578 10.3946 7.49578L10.105 7.84505C10.105 7.84505 10.5123 8.17845 11.204 8.17178C11.332 8.16994 11.4488 8.16073 11.5546 8.14163C11.7317 8.11149 11.8799 8.05604 11.9967 7.97413C12.1179 7.88946 12.2016 7.7781 12.2456 7.64327C12.2635 7.59725 12.2821 7.49762 12.2821 7.40375C12.2821 7.18769 12.2033 7.01513 12.0493 6.90883ZM7.49434 7.32092C7.49179 7.3812 7.50621 7.51419 7.39779 7.59219C7.30031 7.66328 7.08953 7.71781 6.86176 7.7162C6.65516 7.7162 6.49835 7.68514 6.39249 7.62831C6.28431 7.56964 6.24452 7.5059 6.24452 7.42722C6.24452 7.34185 6.29105 7.24292 6.42553 7.1969C6.49835 7.17343 6.61863 7.15341 6.78219 7.14674C7.12419 7.13247 7.27402 7.12741 7.49434 7.06529V7.32092ZM7.68559 6.02691C7.50109 5.90128 7.24959 5.84192 6.93109 5.84192C6.29687 5.841 5.84994 6.16588 5.84994 6.16588L6.14541 6.51768C6.14541 6.51768 6.41715 6.30002 6.92434 6.30002H6.92527C7.12838 6.30002 7.26053 6.32188 7.35638 6.3603C7.4527 6.40218 7.48318 6.44751 7.48318 6.50595C7.48504 6.56876 7.452 6.62835 7.281 6.65343C7.07184 6.67345 6.88549 6.69531 6.67377 6.71878C6.36644 6.75398 6.14541 6.81587 6.00559 6.91228C5.85157 7.01766 5.77014 7.19115 5.77107 7.40628C5.77014 7.64994 5.87018 7.84666 6.05887 7.97735C6.24685 8.10896 6.51277 8.17086 6.85594 8.17178C7.25215 8.16925 7.63906 8.0328 7.78563 7.89613C7.92778 7.76061 7.96594 7.57217 7.96594 7.45575V6.57129C7.96594 6.56876 7.96687 6.56209 7.96687 6.55127C7.96756 6.33108 7.86869 6.15 7.68559 6.02691ZM9.20063 7.70953C8.80512 7.70953 8.8 7.29906 8.8 7.16354V6.5186H9.73155V6.08903H8.8V5.5313L8.32236 5.73884V7.21369C8.32236 7.34185 8.3098 8.17178 9.18458 8.17178C9.61383 8.17178 9.90348 7.84505 9.90348 7.84505L9.61383 7.49578C9.61383 7.49578 9.41816 7.70953 9.20063 7.70953Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2724_119674">
        <rect
          width="11.9759"
          height="12"
          fill="white"
          transform="translate(1 1)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const handlingIcon = (size = 14) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="14" height="14" rx="2" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.9375 4.17336C4.36233 3.58415 4.83405 3.01723 5.35336 2.47933C5.87454 1.93972 6.42559 1.44627 7.00179 1L6.38528 3.47122L3.9375 4.17336Z"
      fill="#C9CBCD"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.21796 5.23783C7.49524 5.1645 6.76837 5.03942 6.04292 4.8586C5.31505 4.67706 4.6122 4.44649 3.9375 4.17061L6.38585 3.46875L8.21796 5.23783Z"
      fill="#5B5C5E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.99904 1C7.29694 1.66255 7.5521 2.3544 7.75822 3.07312C7.96506 3.79427 8.11673 4.51814 8.21507 5.2403L6.38281 3.47079L6.99904 1Z"
      fill="#999B9D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.07098 9.24636C2.64171 8.66044 2.24847 8.03663 1.89755 7.37651C1.54519 6.71411 1.24629 6.03755 1 5.35156L3.15974 6.70153L3.07098 9.24636Z"
      fill="#999B9D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.40802 5.51562C5.11499 6.18017 4.77135 6.83286 4.37525 7.46681C3.97772 8.10306 3.54117 8.70028 3.07031 9.25647L3.15937 6.71121L5.40802 5.51562Z"
      fill="#5B5C5E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 5.34842C1.72215 5.2698 2.45903 5.24107 3.2062 5.26723C3.95594 5.29353 4.69153 5.37287 5.40869 5.50252L3.1596 6.69796L1 5.34842Z"
      fill="#C9CBCD"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.63342 11.6445C6.94329 11.8715 6.22842 12.0526 5.49212 12.1826C4.75338 12.3127 4.01751 12.3881 3.28906 12.4103L5.24025 10.7734L7.63342 11.6445Z"
      fill="#5B5C5E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.78906 8.25781C5.33054 8.74196 5.84499 9.27043 6.32543 9.84292C6.80786 10.4178 7.24084 11.0174 7.6245 11.6372L5.23119 10.7656L4.78906 8.25781Z"
      fill="#999B9D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.28906 12.4031C3.43758 11.6919 3.63799 10.9823 3.89357 10.2798C4.1503 9.57462 4.45306 8.89992 4.79798 8.25781L5.23997 10.7661L3.28906 12.4031Z"
      fill="#C9CBCD"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.318 8.04688C11.3207 8.77317 11.2722 9.50905 11.168 10.2492C11.0638 10.9921 10.9077 11.7154 10.704 12.415L9.75 10.0534L11.318 8.04688Z"
      fill="#999B9D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.22656 9.69917C7.85452 9.3338 8.51606 9.00789 9.20906 8.72786C9.90477 8.44683 10.6088 8.22027 11.3166 8.04688L9.74853 10.0537L7.22656 9.69917Z"
      fill="#C9CBCD"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7027 12.4113C10.0722 12.0505 9.45921 11.6404 8.87014 11.1799C8.27877 10.7181 7.73073 10.2216 7.22656 9.69531L9.74881 10.0498L10.7027 12.4113Z"
      fill="#5B5C5E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.03125 3.42969C9.72281 3.65154 10.4077 3.92513 11.0796 4.2529C11.7541 4.58182 12.3934 4.95347 12.996 5.36358L10.4553 5.54097L9.03125 3.42969Z"
      fill="#999B9D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.34159 7.83008C9.18779 7.12008 9.08244 6.3902 9.03012 5.64446C8.9778 4.89615 8.98009 4.15656 9.03398 3.42969L10.458 5.54126L9.34159 7.83008Z"
      fill="#C9CBCD"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.001 5.35156C12.4629 5.83943 11.8836 6.29571 11.2639 6.71382C10.6418 7.13336 10.0001 7.5013 9.34375 7.81806L10.4606 5.52896L13.001 5.35156Z"
      fill="#5B5C5E"
    />
  </svg>
);
